import { render, staticRenderFns } from "./TextMarquee.vue?vue&type=template&id=4b31e26e"
import script from "./TextMarquee.vue?vue&type=script&lang=js"
export * from "./TextMarquee.vue?vue&type=script&lang=js"
import style0 from "./TextMarquee.vue?vue&type=style&index=0&id=4b31e26e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports